<template>

  <div class="main-menu menu-fixed menu-light menu-accordion menu-shadow" data-scroll-to-active="true">
    <div class="navbar-header">
      <ul class="nav navbar-nav flex-row">
        <li class="nav-item mr-auto">
          <router-link to="/" class="navbar-brand">
            <h3 class="brand-text">Golden Spoon</h3>
          </router-link>
        </li>
        <li class="nav-item d-md-none"><a class="nav-link close-navbar"><i class="ft-x" style="color:#000"></i></a></li>
      </ul>
    </div>
    <div class="main-menu-content">
      <ul class="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation">
        <li class="nav-item">
          <router-link to="/"><i class="ft-home"></i><span class="menu-title">Home</span></router-link>
        </li>
        <li class="nav-item">
          <router-link to="/messages"><i class="ft-message-square"></i><span class="menu-title">Messages</span></router-link>
        </li>
        <li class="nav-item">
          <router-link to="/rewards"><i class="ft-award"></i><span class="menu-title">Rewards</span></router-link>
        </li>
        <li class="nav-item">
          <router-link to="/faq"><i class="ft-list"></i><span class="menu-title">FAQ's</span></router-link>
        </li>
        <li class="nav-item">
          <router-link to="/contact"><i class="ft-life-buoy"></i><span class="menu-title">Contact Us</span></router-link>
        </li>
        <li class="nav-item">
          <router-link to="/about"><i class="ft-more-horizontal"></i><span class="menu-title">About Us</span></router-link>
        </li>
        <li class="nav-item">
          <router-link to="/history"><i class="ft-inbox"></i><span class="menu-title">Transaction History</span></router-link>
        </li>
        <li class="nav-item">
          <a href="#" v-on:click="logout()"><i class="ft-power"></i><span class="menu-title">Log Out</span></a>
        </li>
      </ul>
    </div>
    <div class="navigation-background"></div>
  </div>
</template>

<script>
export default {
  name: 'appLayout',
  mounted: function () {
    $('#main-menu-navigation a').on('click', function () {
      $('a.close-navbar').trigger('click')
    })

    $('.app-content').on('click', function () {
      $('body').addClass('menu-hide').removeClass('menu-open')
    })
  },
  methods: {
    logout: function () {
      localStorage.clear()
      this.$router.push('/login')
    }
  }
}
</script>
